module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/corp/corp.component.css
// module id = ./src/app/corp/corp.component.css
// module chunks = main